import React, { useCallback } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useSelector, useDispatch } from 'react-redux';
import { RuleFilterConfig, RuleFilterActionConfig } from '../constants/createSegment';
import { activeRuleFiltersSelector, ruleFiltersSelector } from '../selectors/selectors';
import { resetRuleFilters, updateActiveFilters } from '../actions/ruleFiltersActions';
import { formatDateFields } from '../util/commonUtils';
import {
  setEditOperation,
  setSegmentData,
  updateSegmentApiStatus,
} from '../actions/createSegmentActions';
import { parseRuleFilters } from '../util/parseRuleFilters';
import { getApplicableFilters } from '../util/ruleFilterUtils';
import cloneDeep from 'lodash/cloneDeep';

const useRuleFilter = () => {
  const dispatch = useDispatch();
  const activeFilters = useSelector(activeRuleFiltersSelector);
  const ruleFilters = useSelector(ruleFiltersSelector);

  let requiredFields = [];
  let isValid = false;

  if (isEmpty(activeFilters)) {
    return {
      activeFilters,
      requiredFields,
      isValid,
    };
  }

  activeFilters?.forEach(filter => {
    // get the required fields from config
    const fields = RuleFilterConfig[filter] || [];
    requiredFields = [...requiredFields, ...fields];
  });

  isValid =
    requiredFields?.filter(fields => {
      if (typeof ruleFilters[fields] === 'number') {
        return ruleFilters[fields] === 0;
      } else {
        return isEmpty(ruleFilters[fields]);
      }
    })?.length === 0;

  const populateSegmentData = useCallback(
    segmentData => {
      const { segmentName, segmentDescription, segmentId } = segmentData?.segmentIdentifier;
      dispatch(setSegmentData({ segmentName, segmentDescription, segmentId }));

      const parsedRuleFilters = parseRuleFilters(cloneDeep(segmentData?.ruleDetails));

      Object.keys(parsedRuleFilters)?.map(async key => {
        const action = RuleFilterActionConfig[key];
        await dispatch(action(parsedRuleFilters[key]));
      });

      const updatedFilter = getApplicableFilters(parsedRuleFilters);
      dispatch(updateActiveFilters(updatedFilter));
    },
    [ruleFilters],
  );

  const resetSegmentForm = () => {
    dispatch(updateSegmentApiStatus(null));
    dispatch(setEditOperation(false));
    dispatch(setSegmentData({ segmentName: '', segmentDescription: '' }));
    dispatch(resetRuleFilters());
  };

  return {
    activeFilters,
    requiredFields,
    populateSegmentData,
    resetSegmentForm,
    isValid,
  };
};

export default useRuleFilter;
